import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '<'
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Requirement sets' | translate }}</h1>
            <a class="btn add" ng-click="vm.addSet()">{{ 'user.Add set' | translate }}</a>
        </div>
        <div class="form form-filter">
            <form ng-submit="vm.search()" class="form form-filter">
                <div class="fields">
                    <div class="row">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.departmentId"
                                ng-options="item.id as item.value for item in vm.departments">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.drlRoleId"
                                ng-options="item.id as item.value for item in vm.roles">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <select class="form-control" ng-model="vm.filter.levelId"
                                ng-options="item.id as item.value for item in vm.levels">
                            <option value=""></option>
                        </select>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" class="btn discrete" ng-click="vm.resetFilter()" value="{{ 'general.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'general.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.list.loading">
            <thead>
            <tr>
                <th>{{ 'user.Role' | translate }}</th>
                <th>{{ 'user.Department' | translate }}</th>
                <th>{{ 'user.Level' | translate }}</th>
                <th class="none dt-hide">{{ 'user.Skills and Competences' | translate }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="requirementSets in vm.list.items">
                <td ng-if="requirementSets.departmentName">{{ requirementSets.departmentName }}</td>
                <td ng-if="!requirementSets.departmentName">{{ 'course.All departments' | translate }}</td>
                <td ng-if="requirementSets.roleName">{{ requirementSets.roleName }}</td>
                <td ng-if="!requirementSets.roleName">{{ 'course.All roles' | translate }}</td>
                <td ng-if="requirementSets.levelName">{{ requirementSets.levelName }}</td>
                <td ng-if="!requirementSets.levelName">{{ 'course.All levels' | translate }}</td>
                <td>
                    <div ng-non-bindable>
                        <user-competence-requirements-competences></user-competence-requirements-competences>
                    </div>
                </td>
                <td class="actions">
                    <a class="btn edit" ng-click="vm.editSet(requirementSets)">{{ 'general.Edit' | translate }}</a>
                    <a class="btn add" ng-click="vm.addCompetencesToDrl(requirementSets)">{{ 'user.Add requirement' | translate }}</a>
                </td>
            </tr>
            </tbody>
        </table>

`
})
export default class {
    constructor (lodash, CompetenceRequirementResource, ListFactory, ModalService, DatatableService, $rootScope, DATATABLES, CLASSIFIER_ENUM) {
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.CompetenceRequirementResource = CompetenceRequirementResource;
        this.ModalService = ModalService;
        this.DatatableService = DatatableService;
        this.ListFactory = ListFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;

        this.DATATABLES = this.lodash.assign({}, DATATABLES, this.DatatableService.getResponsiveOption(([rowIndex]) => {
            const $newScope = this.$rootScope.$new();
            $newScope.vm = this;
            $newScope.index = rowIndex;
            return $newScope;
        }));
    }

    $onInit () {
        this.filter = {};
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.list = this.ListFactory.createWithPagination(this.CompetenceRequirementResource.query.bind(this.CompetenceRequirementResource));
        this.search();
    }

    search () {
        this.list.fetch(this.lodash.assign(this.filter, { expand: 'requiredCompetences,requiredCompetences.competency' })).then(items => {
            this.requiredCompetences = items.map(item => item.requiredCompetences);
        });
    }

    resetFilter () {
        this.filter = {};
        this.search();
    }

    addSet () {
        return this.ModalService.open({
            template: `<modals-competence-requirements-add on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update()" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        }).then(() => {
            this.list.fetch();
        });
    }

    editSet (set) {
        return this.ModalService.open({
            template: `<modals-competence-requirements-edit set="vm.set" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update()" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.set = set;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        }).then(() => {
            this.search();
        });
    }

    addCompetencesToDrl (drlRequirement) {
        return this.ModalService.open({
            template: `<modals-competence-requirements-add-competence drl-requirement="vm.drlRequirement" on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update()" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.drlRequirement = drlRequirement;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        }).then(() => {
            this.search();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/requirements/index.js